import { gql } from 'react-apollo';

export const full = gql`
  fragment allDailyScripturesFields on DailyScripture {
    id
    day
    type
    type_value
    headline
    text
    comment
    image {
      default
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/fragments/dailyScripture.js